import { Button } from '@heroui/react';
import { MinusSquareDashed } from 'iconoir-react';

import i18n from '~/common/helpers/i18n';

type AgentLogsZeroRowsViewProps = {
  hasFilters: boolean;
  onClear: () => void;
};

export function AgentLogsZeroRowsView({
  hasFilters,
  onClear
}: AgentLogsZeroRowsViewProps) {
  return (
    <div
      className='flex flex-col gap-4 py-12'
      data-testid='monitor-agent-logs-zero-rows-view'
    >
      <div className='flex items-center justify-center px-6 py-2'>
        <div className='rounded-lg bg-surface-container p-4'>
          <MinusSquareDashed className='h-12 w-12 text-on-surface' />
        </div>
      </div>

      <div className='flex flex-col items-center justify-center gap-6 text-center'>
        <div>
          <h2
            className='mb-1 text-headline-md font-semibold text-on-surface'
            data-testid='monitor-agent-logs-zero-rows-title'
          >
            {i18n.t('scenes.monitor.agentLogs.zero_rows.title')}
          </h2>
          <p
            className='text-body-regular-md text-on-surface'
            data-testid='monitor-agent-logs-zero-rows-subtitle'
          >
            {i18n.t('scenes.monitor.agentLogs.zero_rows.subtitle')}
          </p>
        </div>
        {hasFilters ? (
          <Button
            variant='bordered'
            size='md'
            color='primary'
            className='h-8 border-1 text-sm font-semibold leading-tight tracking-tight'
            onPress={onClear}
            data-testid='monitor-agent-logs-zero-rows-clear-filters-button'
          >
            {i18n.t('scenes.monitor.agentLogs.zero_rows.clear_filters')}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
